import React from "react";

import Page from "../components/Page";

function MassMedia() {
  return <Page department="mass media"></Page>;
}

export default MassMedia;
